import React, { useState } from 'react';
import './ProductSummary.scss';
import Rating from '../UI/Rating/Rating';
import CTAButton from '../UI/CTA/CTAButton/CTAButton';
import Loader from '../UI/Icons/Loader/Loader';

/**
 * Renders product summary
 * @param {object} product
 * @param {string} starsAssetUrl
 * @param {boolean} isHeroProductListing
 * @param {function} addToCart
 * @param {boolean} showRating
 * @param {boolean} showPrice
 * @param {boolean} isLinked
 * @param {boolean} enablePreorder
 * @returns {JSX.Element}
 * @constructor
 */
const ProductSummary = ({
  product,
  starsAssetUrl,
  isHeroProductListing = false,
  addToCart,
  showRating,
  showPrice,
  isLinked = false,
  enablePreorder,
}) => {
  const [fetching, setFetching] = useState(false);

  const addAction = async () => {
    setFetching(true);
    await addToCart(properties, product?.title)
      .then(() => setFetching(false))
      .catch(() => {
        setFetching(false);
        console.error('Error fetching, please try again');
      });
  };

  const HeadingTag = isHeroProductListing ? 'h2' : 'h3';

  const properties = {
    quantity: 1,
    id: product?.variants[0]?.id,
  };

  return (
    <>
      {showRating && product?.rating?.count && (
        <div className="c-product-summary__rating">
          <Rating {...product?.rating} starsAssetUrl={starsAssetUrl} />
        </div>
      )}
      <div className={`c-product-summary__title ${HeadingTag}-roobert`}>
        <a className="color-black" href={product?.url}>
          <HeadingTag>{product?.title}</HeadingTag>
        </a>
      </div>
      {showPrice && (
        <div className="c-product-summary__price body-2">
          <span>{product?.price}</span>
        </div>
      )}
      <div className={`c-product-summary__description body-${isHeroProductListing ? '1' : '2'}`}>
        <p>{product?.description}</p>
      </div>
      <div className="c-product-summary__ctas-container">
        <div className="c-product-summary__product-link text-cta cta color-black">
          <a className="color-black" href={product?.url}>
            See details
          </a>
        </div>
        <div className="c-product-summary__add-to-cart">
          <CTAButton
            isButton={!isLinked}
            onClick={!isLinked && product?.variants[0]?.available ? addAction : null}
            ariaLabel={
              !isLinked
                ? product?.variants[0]?.available
                  ? `Add To Cart–${product?.price}`
                  : 'Sold Out'
                : enablePreorder
                ? 'Talk to Sales'
                : 'Shop Now'
            }
            type="primary"
            text={
              !isLinked ? (
                product?.variants[0]?.available ? (
                  fetching ? (
                    <Loader lightMode={true} />
                  ) : (
                    `Add to Cart–${product?.price}`
                  )
                ) : (
                  'Sold Out'
                )
              ) : enablePreorder ? (
                'Talk to Sales'
              ) : (
                'Shop Now'
              )
            }
            additionalClasses="cta"
            disabled={!isLinked && !product?.variants[0]?.available}
            link={enablePreorder ? `${product?.url}#preorder-form` : product?.url}
          />
        </div>
      </div>
    </>
  );
};

export default ProductSummary;
